import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import * as React from "react";
import { useAirbrake } from "~/components/providers/airbrake";

export const useMutationWithAirbrake = <TData, TError, TVariables, TContext>(
  mutationOptions: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const mutationResult = useMutation<TData, TError, TVariables, TContext>({
    ...mutationOptions,
  });
  const { notify } = useAirbrake();

  React.useEffect(() => {
    (async () => {
      if (mutationResult.error) {
        const error =
          mutationResult.error instanceof Error
            ? mutationResult.error
            : new Error(String(mutationResult.error));
        const notice = await notify(error);
        return notice;
      }
    })();
  }, [mutationResult.error, notify]);

  return mutationResult;
};
